import { forwardRef } from 'react'

import cn from 'classnames'

import styles from './QuickActionButton.module.scss'
import { QuickActionButtonProps } from './QuickActionButton.types'

export const QuickActionButton = forwardRef<
  HTMLButtonElement,
  QuickActionButtonProps
>(({ color, className, style, children, ...rest }, ref) => (
  <button
    ref={ref}
    className={cn(styles.quickActionButton, className)}
    style={{ ...style, backgroundColor: color }}
    {...rest}
  >
    {children}
  </button>
))

QuickActionButton.displayName = 'QuickActionButton'
